// src/pages/clientsAccountsMenu.js

import "../styles/clientsAccountsMenu.css";
import "../styles/loadingModal.css";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import useAuth from "../components/useAuth";
import FilterField from "../components/salesFilters";
import GenericModal from "../components/filtersModal";
import LoadingModal from "../components/loadingModal";

import homeIcon from "../assets/home-icon.png";

import * as XLSX from "xlsx";

import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

// =========================================================
// MODAL CUENTA CORRIENTE DEL CLIENTE
// =========================================================
//********************************************************************************** */
export default function ClientsAccountsMenu() {

  const { userName, clientName } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Galileo Analytics - Cuentas Corrientes";
  }, []);

  useEffect(() => {

    obtenerUltimaSincronizacion();

  }, []);

  // =========================================================
  // MODAL
  // =========================================================

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalData, setModalData] = useState([]);

  const [ultimaSincronizacion, setUltimaSincronizacion] = useState(null);

  const obtenerUltimaSincronizacion = async () => {

    try {

      const response = await fetch(
        "api/lastSync.php",
        {
          method: "GET",
          credentials: "include"
        }
      );
      if (response.status === 401) {
        return;
      }
      // Primero obtenemos el texto crudo
      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {

        return;
      }
      if (data.success) {
        setUltimaSincronizacion(
          data.ultimaSincronizacion
        );
      } else {

      }
    } catch (error) {

      console.error(
        "Error obteniendo última sincronización:",
        error
      );

    }
  };

  const openFilterModal = async (type) => {

    setModalData([]);
    setModalType(type);
    setModalTitle("Seleccionar " + type);
    setModalOpen(true);

    if (type === "tipoCliente") {

      setModalData([
        {
          label: "Cliente Individual",
          value: "individual"
        },
        {
          label: "Todos los Clientes",
          value: "todos"
        }
      ]);

      return;
    }

    try {

      const response = await fetch(
        "api/clientsAccountsFilters.php?filter=" + type,
        {
          method: "GET",
          credentials: "include"
        }
      );

      if (response.status === 401) {

        localStorage.clear();

        alert("Sesión expirada");

        navigate("/");

        return;
      }

      const text = await response.text();

      try {
        const data = JSON.parse(text);
        setModalData(data);
      } catch (jsonError) {
        console.error("JSON parse error:", text);
        setModalData([]);
      }

    } catch (error) {
      console.error("Error cargando datos:", error);
      setModalData([]);
    }
  };

  const openOrderModal = () => {

    setModalType("orderBy");
    setModalTitle("Ordenar Por:");

    setModalData([
      { label: "Más Reciente", value: "fechaDesc" },
      { label: "Más Antiguo", value: "fechaAsc" },
      { label: "Cliente", value: "clienteAsc" },
    ]);

    setModalOpen(true);
  };

  const openPeriodModal = () => {

    setModalType("period");
    setModalTitle("Clientes con movimientos en período:");

    setModalData([
      { label: "Hoy", value: "hoy" },
      { label: "Esta Semana", value: "semana" },
      { label: "Este Mes", value: "mes" }
    ]);

    setModalOpen(true);
  };

  const closeFilterModal = () => {
    setModalOpen(false);
    setModalType("");
    setModalTitle("");
  };

  // =========================================================
  // FILTROS
  // =========================================================

  const filters = [

    {
      label: "Tipo de consulta",
      type: "text",
      name: "tipoClienteLabel",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("tipoCliente")
    },

    {
      label: "Clientes con movimientos en período",
      type: "select",
      name: "period",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openPeriodModal()
    },
    //{label: "Clientes con movimientos entre fechas:"},
    { label: "Desde", type: "date", name: "fechaDesde" },
    { label: "Hasta", type: "date", name: "fechaHasta" },

    {
      label: "Cliente",
      type: "text",
      name: "cliente",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("cliente")
    },

    {
      label: "Sucursal",
      type: "text",
      name: "sucursal",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("sucursal"),
      placeholder: "Central por Defecto"
    }

  ];

  const [filtersState, setFiltersState] = useState({

    tipoClienteLabel: "Todos los Clientes",
    tipoCliente: "todos",

    fechaDesde: "",
    fechaHasta: "",

    cliente: "",
    cCliente: "",

    sucursal: "",
    cSucursal: "",

    period: "Hoy",
    periodValue: "hoy"
  });

  // =========================================================
  // SELECCIÓN DE MODAL
  // =========================================================

  const handleSelect = (item) => {

    if (!modalType) return;

    const pick = (obj, ...keys) => {
      for (const k of keys) {
        if (obj == null) continue;
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
          return obj[k];
        }
      }
      return undefined;
    };

    switch (modalType) {

    case "tipoCliente": {

      setFiltersState(prev => {

        // ================================================
        // TODOS LOS CLIENTES
        // ================================================
        if (item.value === "todos") {

          return {
            ...prev,

            tipoCliente: "todos",
            tipoClienteLabel: item.label,

            // No puede quedar un cliente individual
            cliente: "",
            cCliente: ""
          };
        }

        // ================================================
        // CLIENTE INDIVIDUAL
        // ================================================
        return {
          ...prev,

          tipoCliente: "individual",
          tipoClienteLabel: item.label,

          // Al consultar un cliente individual,
          // se eliminan los filtros temporales.
          period: "",
          periodValue: "",
          fechaDesde: "",
          fechaHasta: ""
        };

      });

      break;
    }
      case "cliente": {

        const text = pick(
          item,
          "cliente",
          "CLIENTE",
          "nombre",
          "NOMBRE"
        );

        const val = pick(
          item,
          "cCliente",
          "CCLIENTE",
          "id",
          "ID"
        );

        setFiltersState(prev => ({

          ...prev,

          // Seleccionar un cliente implica
          // consulta individual.
          tipoCliente: "individual",
          tipoClienteLabel: "Cliente Individual",

          cliente: text ?? "",
          cCliente: val ?? "",

          // Un cliente individual no utiliza
          // filtros temporales.
          period: "",
          periodValue: "",
          fechaDesde: "",
          fechaHasta: ""

        }));

        break;
      }
      case "sucursal": {

        const text = pick(item, "sucursal", "SUCURSAL", "nombre", "NOMBRE");
        const val = pick(item, "cSucursal", "CSUCURSAL", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          sucursal: text ?? "",
          cSucursal: val ?? ""
        }));

        break;
      }
      case "period": {

        setFiltersState(prev => ({

          ...prev,

          // ================================================
          // PERÍODO
          // ================================================

          period: item.label,
          periodValue: item.value,

          // El período elimina fechas manuales.
          fechaDesde: "",
          fechaHasta: "",

          // Un período siempre consulta todos los clientes.
          tipoCliente: "todos",
          tipoClienteLabel: "Todos los Clientes",

          // Por lo tanto no puede quedar un cliente.
          cliente: "",
          cCliente: ""

        }));

        break;
      }

      default:
        break;
    }

    closeFilterModal();
  };

// =========================================================
// DATA
// =========================================================

  const [currentAccounts, setCurrentAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingMovements, setLoadingMovements] = useState(false);

  const [accountMovements, setAccountMovements] = useState([]);

  const [accountTotals, setAccountTotals] = useState({
    debe: 0,
    haber: 0,
    saldo: 0,
    saldo_adelanto: 0
  });

  // =========================================================
  // LIMPIAR FILTROS
  // =========================================================

  const clearFilters = () => {

    setFiltersState({

      tipoClienteLabel: "Todos los Clientes",
      tipoCliente: "todos",

      cliente: "",
      cCliente: "",

      sucursal: "",
      cSucursal: "",
      fechaDesde: "",
      fechaHasta: "",

      period: "Hoy",
      periodValue: "hoy"
    });

    setCurrentAccounts([]);

    setSelectedAccount(null);

    setAccountMovements([]);

    setAccountTotals({
      debe: 0,
      haber: 0,
      saldo: 0,
      saldo_adelanto: 0
    });
  };

  // =========================================================
  // UTILIDADES
  // =========================================================

  const formatMoney = (value) => {

    return Number(value || 0).toLocaleString("es-AR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };

  // =========================================================
  // APLICAR FILTROS
  // =========================================================

const handleApplyFilters = async (e) => {

  e.preventDefault();

  // =====================================================
  // VALIDACIÓN
  // =====================================================

  if (
    filtersState.tipoCliente === "individual" &&
    !filtersState.cCliente
  ) {

    alert("Debe seleccionar un cliente.");

    return;
  }

  setLoading(true);

  setCurrentAccounts([]);

  setSelectedAccount(null);

  setAccountMovements([]);

  setAccountTotals({
    debe: 0,
    haber: 0,
    saldo: 0,
    saldo_adelanto: 0
  });

  const filtros = {

    tipoCliente:
      filtersState.tipoCliente || "todos",

    cCliente:
      filtersState.tipoCliente === "individual"
        ? filtersState.cCliente || null
        : null,

    cSucursal:
      filtersState.cSucursal || null,

    fechaDesde:
      filtersState.fechaDesde || null,

    fechaHasta:
      filtersState.fechaHasta || null,

    period:
      filtersState.periodValue || null

  };

  try {

    const response = await fetch(
      "api/clientsAccountsMenu.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify(filtros)
      }
    );

    if (response.status === 401) {

      localStorage.clear();

      alert("Sesión expirada");

      navigate("/");

      return;
    }

    const text = await response.text();

    let data;
    try {
      data = JSON.parse(text);
    } catch (error) {
      console.error(
        "Error parseando cuentas corrientes:",
        text
      );
      alert("El servidor devolvió una respuesta inválida.");
      return;
    }
    if (!data.success) {
      alert(
        data.message ||
        "No se pudieron obtener las cuentas corrientes."
      );
      return;
    }
    setCurrentAccounts(
      Array.isArray(data.data)
        ? data.data
        : []
    );

    setAccountMovements(
      Array.isArray(data.movimientos)
        ? data.movimientos
        : []
    );

    setAccountTotals(
      data.totales || {
        debe: 0,
        haber: 0,
        saldo: 0,
        saldo_adelanto: 0
      }
    );

    setAccountMovements([]);
    setSelectedAccount(null);    
  } catch (error) {
    console.error(
      "Error obteniendo cuentas corrientes:",
      error
    );
    alert(
      "Ocurrió un error al obtener las cuentas corrientes."
    );
  } finally {
    setLoading(false);
  }
};

const pieData = [
  {
    name: "Debe",

    value: currentAccounts.reduce(
      (total, account) =>
        total + Number(account.debe || 0),
      0
    )
  },

  {
    name: "Haber",

    value: currentAccounts.reduce(
      (total, account) =>
        total + Number(account.haber || 0),
      0
    )
  }
];

const PIE_COLORS = [
  "#dc2626",
  "#16a34a"
];

const handleSelectAccount = (account) => {

  setSelectedAccount(account);

  // Los movimientos ya vienen en la misma respuesta
  // del filtro.
  //
  // En este momento PHP devuelve movimientos
  // únicamente para el cliente individual.

};

// =========================================================
// OBTENER DETALLE DE CUENTA
// =========================================================

const handleAccountClick = async (account) => {

  if (!account?.cCliente) {
    return;
  }

  setSelectedAccount(account);

  setAccountMovements([]);

  setLoadingDetail(true);

  try {

    const response = await fetch(
      "api/clientsAccountsMenu.php",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        credentials: "include",

        body: JSON.stringify({

          accion: "detalle",
          cCliente: account.cCliente,
          cSucursal:
            filtersState.cSucursal || null,

        })
      }
    );

    if (response.status === 401) {

      localStorage.clear();

      alert("Sesión expirada");

      navigate("/");

      return;
    }

    const text = await response.text();

    let data;

    try {

      data = JSON.parse(text);

    } catch (error) {

      console.error(
        "Error parseando detalle de cuenta:",
        text
      );

      alert(
        "El servidor devolvió una respuesta inválida."
      );

      return;
    }

    if (!data.success) {

      alert(
        data.message ||
        "No se pudo obtener el detalle de la cuenta."
      );

      return;
    }

    setAccountMovements(
      Array.isArray(data.data)
        ? data.data
        : []
    );

  } catch (error) {

    console.error(
      "Error obteniendo detalle de cuenta:",
      error
    );

    alert(
      "Ocurrió un error al obtener el detalle de la cuenta."
    );

  } finally {

    setLoadingDetail(false);

  }
};

const accountChartData = [
  {
    name: "Debe",
    value: Number(accountTotals.debe || 0)
  },
  {
    name: "Haber",
    value: Number(accountTotals.haber || 0)
  }
].filter(item => item.value > 0);

const loadAccountMovements = async (account) => {

  if (!account || !account.cCliente) {
    return;
  }

  setSelectedAccount(account);

  setAccountMovements([]);

  setLoadingMovements(true);

  try {

    const response = await fetch(
      "api/clientsAccountsMenu.php",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        credentials: "include",

        body: JSON.stringify({
        action: "movimientos",
        cCliente: account.cCliente,
        cSucursal: filtersState.cSucursal || ""
      })
      }
    );

    if (response.status === 401) {

      localStorage.clear();

      alert("Sesión expirada");

      navigate("/");

      return;
    }

    const text = await response.text();

    let data;

    try {

      data = JSON.parse(text);

    } catch (error) {

      console.error(
        "Error parseando movimientos:",
        text
      );

      return;
    }

    if (!data.success) {

      console.error(
        "Error obteniendo movimientos:",
        data.message
      );

      return;
    }

    setAccountMovements(
      Array.isArray(data.data)
        ? data.data
        : []
    );

  } catch (error) {

    console.error(
      "Error obteniendo movimientos:",
      error
    );

  } finally {

    setLoadingMovements(false);

  }
};
// =========================================================
  // RENDER
  // =========================================================

  return (
    <>

      <div className="sales-menu">

        {/* ================================================= */}
        {/* FILTROS */}
        {/* ================================================= */}

        <aside className="filters-section">

          <div className="filters-header">

            <button
              type="button"
              className="home-button"
              onClick={() => navigate("/menu")}
            >
              <img src={homeIcon} alt="Home" />
            </button>

          </div>

          <h2>Filtros</h2>

          <form
            className="sales-filters-form"
            onSubmit={handleApplyFilters}
          >

            <div className="filters-body">

              {filters.map((f) => {

              let hiddenVal = "";

              if (f.name === "cliente") {
                hiddenVal = filtersState.cCliente || "";
              }
              else if (f.name === "sucursal") {
                hiddenVal = filtersState.cSucursal || "";
              }

              <p>Movimientos emitidos a cuenta:</p>

                return (
                  <FilterField
                    key={f.name}
                    {...f}
                    value={filtersState[f.name] || ""}
                    hiddenValue={hiddenVal}
                    onChange={(e) => {

                      const value = e.target.value;

                      setFiltersState(prev => {

                        const next = {
                          ...prev,
                          [f.name]: value
                        };

                        // ================================================
                        // FECHAS
                        // ================================================

                        if (
                          f.name === "fechaDesde" ||
                          f.name === "fechaHasta"
                        ) {

                          // Las fechas tienen prioridad sobre el período
                          next.period = "";
                          next.periodValue = "";

                          // Una consulta temporal siempre es
                          // sobre todos los clientes.
                          next.tipoCliente = "todos";
                          next.tipoClienteLabel = "Todos los Clientes";

                          // Por lo tanto se elimina el cliente individual.
                          next.cliente = "";
                          next.cCliente = "";
                        }

                        return next;

                      });

                    }}
                    // onChange={(e) => {
                    //   const value = e.target.value;
                    //   setFiltersState(prev => ({
                    //     ...prev,
                    //     [f.name]: value,
                    //     ...(f.name === "fechaDesde" || f.name === "fechaHasta"
                    //       ? {
                    //           period: "",
                    //           periodValue: ""
                    //         }
                    //       : {})
                    //   }));
                    // }}
                  />
                );
              })}

            </div>

            <button
              type="submit"
              className="filter-button"
            >
              Aplicar Filtros
            </button>

            <button
              type="button"
              className="delete-filter-button"
              onClick={clearFilters}
            >
              Borrar Filtros
            </button>

            {/* <button
              type="button"
              className="export-excel-button"
              onClick={exportToExcel}
            >
              Exportar Datos
            </button> */}

          <div className="sync-info">
            <span>
              Última sincronización:{" "}
              {ultimaSincronizacion || "Sin datos"}
            </span>
          </div>

          </form>

        </aside>

        {/* ================================================= */}
        {/* DASHBOARD */}
        {/* ================================================= */}

<main className="sales-data">
  {/* ===================================================== */}
  {/* CABECERA */}
  {/* ===================================================== */}
  <div className="current-account-header">

    <div>

      <span className="account-section-kicker">
        CUENTAS CORRIENTES
      </span>

      <h2>
        Estado de cuentas
      </h2>

      <p>
        {filtersState.tipoCliente === "individual"
          ? "Detalle de la cuenta corriente del cliente seleccionado."
          : "Resumen general de las cuentas corrientes filtradas."
        }
      </p>
    </div>
  </div>

{/* ================================================= */}
{/* GRÁFICO DEBE / HABER */}
{/* ================================================= */}

{/* <div className="accounts-chart-card">
  <div className="accounts-chart-header">
    <div>
      <h3>
        Distribución de movimientos
      </h3>
      <p>
        Debe y Haber del total filtrado
      </p>
    </div>
  </div>
  {accountChartData.length === 0 ? (
    <div className="accounts-chart-empty">
      No hay movimientos monetarios para graficar.
    </div>
  ) : (
    <div className="accounts-pie-container">
        <ResponsiveContainer
          width="100%"
          height={320}
          minWidth={0}
          minHeight={280}
        >
        <PieChart>
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius="65%"
            innerRadius="30%"
            paddingAngle={4}
            labelLine={false}
            label={({ name, percent }) =>
              `${name} ${(percent * 100).toFixed(1)}%`
            }
          >
            {pieData.map(
              (entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={PIE_COLORS[index]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) =>
              `$${formatMoney(value)}`
            }
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
      <div className="accounts-chart-total">
        <span>
          Total
        </span>
        <strong>
          ${
            formatMoney(
              Number(accountTotals.debe || 0) +
              Number(accountTotals.haber || 0)
            )
          }
        </strong>
      </div>
    </div>
  )}
</div> */}

  {/* ===================================================== */}
  {/* RESUMEN GENERAL */}
  {/* ===================================================== */}
  {currentAccounts.length > 0 && (
    <div className="accounts-dashboard">
      <div className="account-dashboard-summary">
        <div className="account-kpi account-kpi-debe">
          <span>Debe total</span>
          <strong>
            ${formatMoney(accountTotals.debe)}
          </strong>
        </div>
        <div className="account-kpi account-kpi-haber">
          <span>Haber total</span>
          <strong>
            ${formatMoney(accountTotals.haber)}
          </strong>
        </div>
        <div className="account-kpi account-kpi-saldo">
          <span>Saldo total</span>
          <strong>
            ${formatMoney(accountTotals.saldo)}
          </strong>
        </div>
        <div className="account-kpi account-kpi-adelanto">
          <span>Adelantos</span>
          <strong>
            ${formatMoney(accountTotals.saldo_adelanto)}
          </strong>
        </div>
      </div>
    </div>
  )}
  {/* ===================================================== */}
  {/* TABLA DE CLIENTES */}
  {/* ===================================================== */}
  <div className="current-accounts-card">
    {currentAccounts.length === 0 ? (
      <div className="empty-chart-message">
        No hay datos de cuentas corrientes para mostrar.
      </div>
    ) : (
      <div className="current-accounts-table-wrapper">
        <table className="current-accounts-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Movimientos</th>
              <th>Debe</th>
              <th>Haber</th>
              <th>Saldo</th>
              <th>Adelantos</th>
            </tr>
          </thead>
          <tbody>
            {currentAccounts.map((account) => (
                <tr
                  key={account.cCliente}
                  onClick={() => loadAccountMovements(account)}
                  className="current-account-row"
                >
                <td>
                  <div className="account-client-cell">
                    <strong>
                      {account.cliente || "Cliente sin nombre"}
                    </strong>
                    <span>
                      Cliente #{account.cCliente}
                    </span>
                  </div>
                </td>
                <td>
                  <span className="movement-count">
                    {account.cantidad_movimientos || 0}
                  </span>
                </td>
                <td className="money-cell money-debe">
                  ${formatMoney(account.debe)}
                </td>
                <td className="money-cell money-haber">
                  ${formatMoney(account.haber)}
                </td>
                <td
                  className={
                    Number(account.saldo) > 0
                      ? "money-cell saldo-deudor"
                      : Number(account.saldo) < 0
                        ? "money-cell saldo-acreedor"
                        : "money-cell saldo-cero"
                  }
                >
                  ${formatMoney(account.saldo)}
                </td>
                <td className="money-cell">
                  ${formatMoney(account.saldo_adelanto)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
  {/* ===================================================== */}
  {/* DETALLE DEL CLIENTE */}
  {/* ===================================================== */}
{selectedAccount && (

  <div className="selected-account-card">

    <div className="selected-account-header">

      <div>

        <h3>
          Cuenta corriente
        </h3>

        <p>
          {selectedAccount.cliente}
        </p>

      </div>

      <div className="selected-account-badge">

        {accountMovements.length} movimientos

      </div>

    </div>

    {loadingMovements ? (

      <div className="empty-data">
        Cargando movimientos...
      </div>

    ) : accountMovements.length === 0 ? (

      <div className="empty-data">
        No hay movimientos para este cliente.
      </div>

    ) : (

      <div className="account-movements">

        <table>

          <thead>

            <tr>
              <th>Fecha</th>
              <th>Tipo</th>
              <th>Comprobante</th>
              <th>Detalle</th>
              <th>Debe</th>
              <th>Haber</th>
              <th>Saldo</th>
              <th>Saldo Adelanto</th>
              <th>Sucursal</th>
            </tr>

          </thead>

          <tbody>

            {accountMovements.map(
              (movement, index) => (

              <tr
                key={`${movement.fecha}-${movement.numeroInterno}-${index}`}
              >

                <td className="account-money account-fecha">
                  {movement.fecha
                    ? String(movement.fecha).substring(0, 10)
                    : "-"
                  }
                </td>

                <td>

                  <span
                    className={
                      movement.tipo === "ADELANTO"
                        ? "movement-type movement-type-adelanto"
                        : "movement-type movement-type-venta"
                    }
                  >
                    {movement.tipo}
                  </span>

                </td>

                <td className="account-money account-comprobante">
                  {movement.nombreComprobante || "-"}
                </td>

                <td className="movement-detail">
                  {movement.detalle || "-"}
                </td>

                <td className="account-money account-debe">

                  {Number(movement.debe || 0) !== 0
                    ? `$${formatMoney(movement.debe)}`
                    : "-"
                  }

                </td>

                <td className="account-money account-haber">

                  {Number(movement.haber || 0) !== 0
                    ? `$${formatMoney(movement.haber)}`
                    : "-"
                  }

                </td>

                <td className="account-money account-saldo">

                  {Number(movement.saldo || 0) !== 0
                    ? `$${formatMoney(movement.saldo)}`
                    : "$0"
                  }

                </td>

              <td className="account-money account-adelanto">
                {Number(movement.saldo_adelanto) !== 0
                  ? `$${formatMoney(movement.saldo_adelanto)}`
                  : "-"
                }
              </td>

              <td className="account-money account-sucursal">
                  {movement.sucursalMovimiento || "-"}
              </td>

              </tr>

            ))}
          </tbody>
        </table>
      </div>
    )}

  </div>
)}
</main>

      </div>

      {/* FOOTER */}

      <div className="sales-menu-footer">

      <div className="footer-left-logo">

        <img
          className="footer-system-logo"
          src={`${process.env.PUBLIC_URL}/logos/galileoinsight-logo.png`}
          alt="Logo Sistema"
        />

      </div>

        <footer>
          <span>
            Sesión Actual: {userName} | {clientName}
          </span>
        </footer>

      </div>

      {/* MODAL */}

      <GenericModal
        title={modalTitle}
        isOpen={modalOpen}
        data={modalData}
        onSelect={handleSelect}
        onClose={closeFilterModal}
      />

      <LoadingModal open={loading} />

    </>
  );
}